module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_perform.js
 **/